import { useEffect, useState } from "react";
import FooterVariacao from "../components/Footer/FooterVariacao";
import Header from "../components/Header";
import ModalCadastro from "../components/modal-cadastro/ModalCadastro";
import FaqBlockVC from "../components/versao-c/faqBlockVC";
import FirstBlockVC from "../components/versao-c/firstBlockVC";
import FloatingWhatsAppVC from "../components/versao-c/FloatingWhatsAppVC";
import MenuMiddleVC from "../components/versao-c/menuMiddleVC";
import RegisterBlockVC from "../components/versao-c/registerBlockVC";
import RzkBlockVC from "../components/versao-c/rzkBlockVC";
import ComoFuncionaBlock from "./blocks/comoFuncionaBlock";
import useScroll from "../hooks/useScroll";

const TesteC = () => {
  const [, setIsMobile] = useState(window.innerWidth < 768);
  const isScrolled = useScroll(50);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="overflow-hidden">
      <ModalCadastro open={false} />
      <Header />
      {/* Espaçamento para compensar o header fixo */}
      {isScrolled && <div className="h-[5rem]" />}
      <FirstBlockVC />
      <MenuMiddleVC />
      <ComoFuncionaBlock />
      <RegisterBlockVC />
      <RzkBlockVC />
      <FaqBlockVC />
      <FloatingWhatsAppVC />
      <FooterVariacao />
    </div>
  );
};

export default TesteC;
